import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { AudioService } from '../../services/audio.service';
import { StreamState } from '../../interfaces/stream-state';
import { PlaylistService } from 'src/app/core/services/playlist.service';

@Component({
  selector: 'app-audio-player',
  templateUrl: './audio-player.component.html',
  styleUrls: ['./audio-player.component.scss']
})
export class AudioPlayerComponent implements OnInit, OnDestroy {

  // msaapDisplayTitle = false;
  // msaapDisplayPlayList = true;
  // pageSizeOptions = [2, 4, 6];
  // msaapDisplayVolumeControls = false;

  // playlistTest: Track[] = [
  //   {
  //     title: 'Audio One Title',
  //     link: "https://www.soundhelix.com/examples/mp3/SoundHelix-Song-1.mp3"
  //   },
  //   {
  //     title: 'Audio Two Title',
  //     link: "https://www.soundhelix.com/examples/mp3/SoundHelix-Song-4.mp3"
  //   },
  //   {
  //     title: 'Audio Three Title',
  //     link: "https://www.soundhelix.com/examples/mp3/SoundHelix-Song-10.mp3"
  //   },
  // ];
  @Input() public playlist: any;
  @Input() public playListObj: any;
  
  state: StreamState;
  currentFile: any = {};

  constructor(
    private audioService: AudioService,
    private _playListService : PlaylistService
  ) {
    this.audioService.getState()
      .subscribe(state => {
        this.state = state;
        if(this.state.duration !== undefined && this.state.duration === this.state.currentTime && !this.state.playing){
          this.next();
        }
      });
  }

  ngOnInit() {
    if(this.playlist && this.playlist.length > 0){
      this.openFile(this.playlist[0], 0);
    }
  }
  playStream(url) {
    this.audioService.playStream(url)
      .subscribe(events => {
        // listening for fun here
      });
  }

  openFile(file, index) {
    this.currentFile = { index, file };
    this.audioService.stop();
    this.playStream(file.link);
  }

  pause() {
    this.audioService.pause();
  }

  play() {
    this.audioService.play();
  }

  stop() {
    this.audioService.stop();
  }

  next() {
    const index = this.currentFile.index + 1;
    const file = this.playlist[index];
    if(file != undefined){
      this.openFile(file, index);
    }
    
  }

  previous() {
    const index = this.currentFile.index - 1;
    const file = this.playlist[index];
    if(file != undefined){
      this.openFile(file, index);
    }
  }

  isFirstPlaying() {
    return this.currentFile.index === 0;
  }

  isLastPlaying() {
    return this.currentFile.index === this.playlist.length - 1;
  }

  onSliderChangeEnd(change) {
    this.audioService.seekTo(change.value);
  }

  moveUpwards(data, i){
    if(this.playlist[i - 1]){
      const temp = this.playlist[i-1];
      this.playlist[i] = temp;
      this.playlist[i-1] = data;
    }
    if(this.playListObj && this.playListObj.id){
      this.shiftContentPackage(data, 'up');
    }
  }
  moveDown(data, i){
    if(this.playlist[i + 1]){
      const temp = this.playlist[i + 1];
      this.playlist[i] = temp;
      this.playlist[i + 1] = data;
    }
    if(this.playListObj && this.playListObj.id){
      this.shiftContentPackage(data, 'down');
    }
  }

  shiftContentPackage(value, data) {
    let obj;

    if (data) {
      obj = {
        direction: data,
        content_relationship_id: value.content_relationship.id
      }
    }

    this._playListService.shiftContentPlaylist(this.playListObj.id, obj).subscribe((response: any) => {
      if (response.success) {
      }
    })
  }

  ngOnDestroy(){
    this.audioService.stop();
  }
}
